import { useEffect } from 'react'
import { PENDING_PURCHASE_KEY, cancelAIPurchase } from '@/lib/ai'

/**
 * Closes a checkout the agent walked away from, so it does not sit in the
 * purchases as pending. Stripe's own back link returns with the purchase in
 * the address. The browser's Back button, a trackpad swipe or a mouse's back
 * button do not, so the purchase is also remembered for the tab when checkout
 * starts. This sits in the layout and runs when a page loads and when one is
 * restored from the back-forward cache. The API asks Stripe before closing
 * anything, so a purchase that was paid is confirmed instead.
 */
const PendingPurchaseCleanup = () => {
    useEffect(() => {
        const close = () => {
            const params = new URLSearchParams(window.location.search)
            let stored: string | null = null
            try {
                stored = window.sessionStorage.getItem(PENDING_PURCHASE_KEY)
                window.sessionStorage.removeItem(PENDING_PURCHASE_KEY)
            } catch {
                stored = null
            }
            // Back from paying: the usage page confirms that one itself.
            if (['success', 'subscribed'].includes(params.get('checkout') || '')) return
            const id = params.get('purchase') || stored
            if (id && /^\d+$/.test(id)) cancelAIPurchase(id).catch(() => {})
        }
        close()
        window.addEventListener('pageshow', close)
        return () => window.removeEventListener('pageshow', close)
    }, [])
    return null
}

export default PendingPurchaseCleanup
